import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { graphql, gql, compose } from 'react-apollo';

import { Step, Stepper, StepLabel } from 'material-ui/Stepper';

import Loader from '../../UI/Loader';
import TownForm from '../TownForm';
import ParticipantsTable from '../ParticipantsTable';

const regListsQuery = gql`
    query RegListQuery($regListId: ID!) {
        regList(_id: $regListId) {
            _id
            season
            townName
            population
            orgHeadName
            address
            addressee
            orgHeadPosition
            juryHeadName
            juryHeadPosition
            email
            phone
            invitations
            pDate
            mDate
            tDate
            vDate
            pPapersNumber
            mPapersNumber
            tPapersNumber
            vPapersNumber
            participantsNumber
            sentPPapersNumber
            sentMPapersNumber
            sentTPapersNumber
            sentVPapersNumber
            sentParticipantsNumber
            payment
            paymentData
            rulesAreFollowed
            ruleBreakersList
            comments
            lastGrade
            participantDrafts {
                _id
                name
                gender
                grade
                school
                email
                paperDrafts {
                    _id
                    round
                    filename
                    file
                    pages
                }
            }
            owner {
                regLists {
                    town {
                        _id
                        tournament {
                            _id
                            gradeSettings {
                                number
                                level
                            }
                        }
                        name {
                            ru
                        }
                        gradeSettings {
                            number
                            level
                        }
                    }
                }
            }
        }
    }
`;

const createTownMutation = gql`
    mutation CreateTownMutation($tournamentId: ID!, $regListId: ID!, $town: TownInput) {
        createTown(tournamentId: $tournamentId, regListId: $regListId, town: $town) {
            _id
            tournament {
                _id
                number
                gradeSettings {
                    number
                    level
                }
            }
            name {
                ru
            }
            gradeSettings {
                number
                level
            }
        }
    }
`;

const registerTownParticipantsMutation = gql`
    mutation RegisterTownParticipantsMutation($townId: ID!, $participants: [ParticipantInput]) {
        registerTownParticipants(townId: $townId, participants: $participants) {
            _id
        }
    }
`;

class RegisterTown extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            regList: PropTypes.object,
        }).isRequired,
        createTown: PropTypes.func.isRequired,
    };

    state = {
        stepIndex: 0,
    };

    componentWillReceiveProps(nextProps) {
        const {
            data: { regList },
            tournamentId,
        } = nextProps;

        if (regList) {
            const registeredRegList = regList.owner.regLists.find(
                regList => regList.town && regList.town.tournament._id === tournamentId
            );

            if (registeredRegList) {
                this.setState({
                    stepIndex: 1,
                    town: registeredRegList.town,
                });
            }
        }
    }

    handleCreateTown = town => {
        this.props
            .createTown({
                variables: {
                    regListId: this.props.data.regList._id,
                    town,
                    tournamentId: this.props.tournamentId,
                },
            })
            .then(({ data: { createTown: town } }) => {
                this.setState({
                    town,
                    stepIndex: 1,
                });
            });
    };

    handleSaveParticipants = participants => {
        const { town } = this.state;

        this.props
            .registerTownParticipants({
                variables: {
                    townId: town._id,
                    participants: participants.map(({ name, grade, school, email, gender, paperDrafts }) => {
                        grade = parseInt(grade, 10);
                        const { level } = town.gradeSettings[grade] || town.tournament.gradeSettings[grade];

                        const papers = paperDrafts.map(({ round, grade, file, filename, pages }) => ({
                            round,
                            grade,
                            file,
                            filename,
                            pages,
                            level,
                        }));

                        return {
                            name,
                            gender,
                            grade,
                            school,
                            email,
                            papers,
                        };
                    }),
                },
            })
            .then(() => {
                this.setState({
                    stepIndex: 2,
                });
            });
    };

    render() {
        const {
            data: { regList, loading },
        } = this.props;
        const { stepIndex, town } = this.state;

        if (loading) {
            return <Loader centerX />;
        }

        if (!regList) {
            return (
                <h2>
                    <FormattedMessage id="RegListAdmin.No such reglist" />
                </h2>
            );
        }

        return (
            <div>
                <h2>{regList.townName}</h2>
                <Stepper activeStep={stepIndex}>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="RegisterTown.Register Town" />
                        </StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>
                            <FormattedMessage id="RegisterTown.Register Participants" />
                        </StepLabel>
                    </Step>
                </Stepper>
                {stepIndex === 0 && <TownForm regList={regList} onCreateTown={this.handleCreateTown} />}
                {stepIndex === 1 && (
                    <ParticipantsTable
                        participants={regList.participantDrafts}
                        editable={true}
                        onSave={this.handleSaveParticipants}
                        season={regList.season}
                    />
                )}
                {stepIndex === 2 && (
                    <div>
                        <h2>
                            <FormattedMessage id="RegisterTown.success" />
                        </h2>
                        <Link to={`/tournaments/${town.tournament.number}/towns/${town._id}/${regList.season}`}>
                            <FormattedMessage id="RegListsList.town" />
                        </Link>
                    </div>
                )}
            </div>
        );
    }
}

export default compose(
    graphql(regListsQuery, {
        options: ({ match }) => ({ variables: { regListId: match.params.id }, fetchPolicy: 'no-cache' }),
    }),
    graphql(createTownMutation, { name: 'createTown' }),
    graphql(registerTownParticipantsMutation, { name: 'registerTownParticipants' }),
    injectIntl
)(RegisterTown);



// WEBPACK FOOTER //
// ./src/Components/RegisterTown/RegisterTown.js